import React, { useState, } from "react";
import "./feedback.scss";
import * as DateUtil from "../../../utils/date";

import Table from '../../elements/table/table';
import Modal from "../../common/modal/modal";

const Feedback = () => {

  const [showValue,setShowValue] = useState(null);
  const [showModal,setShowModal] = useState(false);

  const sideItems = [
    {display:"All", conditions:[]},
    {display:"Feedback", conditions:[{
      column:"type", 
      table: "supportMessages",
      action: "=",
      value:"feedback",
    }]},
    {display:"Bug Report", conditions:[{
      column:"type", 
      table: "supportMessages",
      action: "=",
      value:"bugReport",
    }]},
  ];

  const columns = [
    {table: "supportMessages",value: "id",hide: true,},
    {table: "supportMessages",value: "userId",},
    {table: "supportMessages",value: "type",},
    {table: "supportMessages",value: "text",},
    {table: "supportMessages",value: "createdDate",
      custom: ({v,cv}) => <div>{DateUtil.dateTimeSince(v[cv])}</div>,  
    },
  ]
  const joinOptions = [
    // {joinType:"LEFT JOIN",leftTable:"outputs",rightTable:"addresses",leftColumn:"address",rightColumn:"address",},
  ]

  let timeValue = "";
  if(showValue){
    let timeSince = DateUtil.dateTimeSince(showValue.supportMessagesCreatedDate,1,true);
    let prettyTime = DateUtil.prettifyDateWithTime(showValue.supportMessagesCreatedDate);
    let epochTime = new Date(showValue.supportMessagesCreatedDate).getTime();
    timeValue = timeSince+" - "+prettyTime+" - "+epochTime
  }

  return (
    <div className="feedback-comp">
      <div className="feedback-comp-header">
        <h3>Feedback</h3>
      </div>
      <Table 
        database={"Main"}
        displayName="Feedback"
        name="FeedbackTable"
        sideItems={sideItems}
        sideItemActiveClickFunc={(item) => {
          // console.log("item",item);
        }}
        joinOptions={joinOptions}
        rowOnClickFunc={(value) => {
          setShowValue(value);
          setShowModal(true);
        }}
        columns={columns}
        limit={250}
        />

      <Modal className="feedback-modal" show={showModal} handleClose={() => {setShowModal(false)}}>
        <div className="feedback-modal-main">
          {(showValue)?
            <div className="items">
              <div className='item'>
                <div>Text</div>
                <textarea type="text" disabled value={showValue.supportMessagesText}></textarea>
              </div>
              <div className='item'>
                <div>Date</div>
                <input type="text" disabled value={timeValue} />
              </div>
            </div>
          :null}
          
        </div>
      </Modal>

    </div>
  );
};

export default Feedback;
